
export function register () {
  if ('serviceWorker' in navigator) {
    console.log('registered')
    navigator.serviceWorker.register('/service_worker.js')
  }
}

export function unregister () {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister()
    })
  }
}

export function initA2hs () {
  console.log('initA2hs')
  window.addEventListener('beforeinstallprompt', (event) => {
    window.deferredPrompt = event
    console.log('inited A2hs')
  })
  window.addEventListener('appinstalled', (event) => {
    console.log('👍', 'appinstalled', event)
  })
}



// WEBPACK FOOTER //
// ./src/serviceWorker.js